import React, { Fragment, useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Progress,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
  Modal,
  CardTitle,
  Form
} from "reactstrap"
import { withRouter } from "react-router"

import { Slide, toast, ToastContainer } from "react-toastify"
import Select from "react-select"

const GenerationAuto = props => {
  const [loading, setLoading] = useState(false)
  // Data Table
  const [orders, setOrders] = useState([])
  const [delet, setDelet] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [excel, setExcel] = useState(0)
  const [annee, setAnnee] = useState("")
  const [add, setAdd] = useState(0)
  const [uploadPercent, setUploadPercent] = useState(0)
  const [progress, setProgress] = useState(0);
  const [modal, setModal] = useState(false)
  const pageOptions = {
    loading: true,
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    page: 1,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 10,
      },
      {
        text: "150",
        value: 150,
      },
      {
        text: "All",
        value: orders.length,
      },
    ],
  }
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const [stopped, setStopped] = useState(false);
  const [message, setMessage] = useState("");
  const [display, setDisplay] = useState("none")
  const [departement, setDepartement] = useState([]);
  const [selectDepartement, setSelectDepartement] = useState("");
  const toggle = row => {
    setModal(!modal)
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  const Columns = () => [
    {
      dataField: "code",
      text: "CIN",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "nom_complet", // champ fictif, utilisé juste pour l'affichage
      text: "Nom et prénom",
      sort: true,
      style: { textAlign: "center" },
      headerStyle: () => ({ textAlign: "center" }),
      formatter: (cell, row) => `${row.firstName_fr} ${row.lastName_fr}`,
    },
  ]

  const { SearchBar } = Search

  useEffect(async () => {
    setSelectDepartement("")
    setDisplay("none")
    setOrders([])
    setUploadPercent(0)
    const fetchAnnee = async () => {
      const resD = await API.post("annee/get_by_id", { id: annee_id })
      setAnnee(resD.data.Annee.annee_scolaire)
    }
    await fetchAnnee()
    var cloture_annee = JSON.parse(localStorage.getItem("cloture"))
    setCloture(cloture_annee)
    const userAuth = JSON.parse(localStorage.getItem("UserMenu"))
    const typeArticleSubMenu = userAuth.find(user =>
      user.sous_menu.some(subMenu => subMenu.sous_menu === "Groupe d'examen")
    )
    setAdd(typeArticleSubMenu.sous_menu[0].add)
    setDelet(typeArticleSubMenu.sous_menu[0].delete)
    setExcel(typeArticleSubMenu.sous_menu[0].exel)
    setLoading(true)
    const resDepartement = await API.get("departement/select").then(resDepartement => {
      setDepartement(resDepartement.data.Departement)
      setSelectDepartement("")
    })
  }, [props.semestre,stopped])
  const ReinitialiserEmploi = async () => {
    await API.post("emploi/reinitialiser_emploi", {
      semestre_id: props.semestre.value,
      annee_id,
      departement_id: selectDepartement.value ?? 0,
    }).then(res => {
      setModal(!modal)
      setProgress(0)
    })
  }
  const generationEmploi = async () => {
    const options = {
      onUploadProgress: progressEvent => {
        const { loaded, total } = progressEvent
        let percent = Math.round((loaded * 100) / total)
        console.log(`${loaded}kb of ${total}kb | ${percent}%`)
        if (percent < 100) {
          setUploadPercent(percent)
        }
      },
    }
    await API.post("fiche/enseignantsSansFicheVoeux", {
      semestre_id: props.semestre.value,
      annee_id,
    }).then(res => {
      if(res.data.fiches.length ===0 ){
        setUploadPercent(100)

      }else{

        setOrders(res.data.fiches)
      }

    })
  }
  const generationEmploiDep = async () => {
    const options = {
      onUploadProgress: progressEvent => {
        const { loaded, total } = progressEvent
        let percent = Math.round((loaded * 100) / total)
        console.log(`${loaded}kb of ${total}kb | ${percent}%`)
        if (percent < 100) {
          setUploadPercent(percent)
        }
      },
    }
    await API.post("emploi/genererEmploi_par_departement", {
      semestre_id: props.semestre.value,
      annee_id,departement_id:selectDepartement.value
    }).then(res => {
      if(res.data.fiches.length ===0 ){
        setUploadPercent(100)

      }else{

        setOrders(res.data.fiches)
      }

    })
  }
  const intervalRef = useRef(null);

  const runSchedulerDep = async () => {
    if (stopped) return;
    try {
      const res = await API.post("emploi/start-scheduler",{
        annee_id,
        semestre_id: props.semestre.value,
        type :"departement",
        departement_id:selectDepartement.value
      });
      let data = res.data;
      if (typeof data.progress === "number") {
        setProgress(data.progress);
      }
      if (data.done === true) {
        setStopped(true);
        clearTimeout(intervalRef.current);
      } else {
        // 🔑 Attendre 80s AVANT de relancer, seulement après la fin de l'appel précédent
        intervalRef.current = setTimeout(runSchedulerDep, 20000);
      }
    } catch (error) {
      setMessage("Erreur lors de l'exécution");
    }
    // if (stopped) return;
    // API.post("emploi/start-scheduler",{
    //   semestre_id: props.semestre.value,
    //   annee_id,
    //   departement_id:selectDepartement.value,
    //   type :"departement",
    // }).then((res) => {
    //     let data;
    //     try {
    //       data = res.data;
    //     } catch {
    //       setMessage(res.data.message);
    //       return;
    //     }
    //     if (typeof data.progress === "number") {
    //       setProgress(data.progress);
    //     }
    //     if (data.done === true) {
    //       setStopped(true);
    //       clearInterval(intervalRef.current);
    //     }
    //   })
    //   .catch((error) => {
    //     setMessage("Erreur lors de l'exécution");
    //   });
  };

  // const handleClick = () => {
  //   if (intervalRef.current) clearInterval(intervalRef.current);
  //   setDisplay("")
  //   setStopped(false);
  //   setProgress(0);
  //   setMessage("");
  //   runScheduler();
  //   intervalRef.current = setInterval(runScheduler, 80000);
  // };
  // const runScheduler = () => {
  //   if (stopped) return;
  //   API.post("emploi/start-scheduler")
  //     .then((res) => {
  //       let data;
  //       try {
  //         data = res.data;
  //       } catch {
  //         setMessage(res.data.message);
  //         return;
  //       }
  //       if (typeof data.progress === "number") {
  //         setProgress(data.progress);
  //       }
  //       if (data.done === true) {
  //         setStopped(true);
  //         clearInterval(intervalRef.current);
  //       }
  //     })
  //     .catch((error) => {
  //       setMessage("Erreur lors de l'exécution");
  //     });
  // };

  const handleClick = () => {
    if (intervalRef.current) clearTimeout(intervalRef.current); // on utilise timeout pas interval
    setDisplay("");
    setStopped(false);
    setProgress(0);
    setMessage("");

    // Premier lancement
    runScheduler();
  };

  const runScheduler = async () => {
    if (stopped) return;

    try {
      const res = await API.post("emploi/start-scheduler",{annee_id,semestre_id: props.semestre.value,type :"global",departement_id:0});
      let data = res.data;

      if (typeof data.progress === "number") {
        setProgress(data.progress);
      }

      if (data.done === true) {
        setStopped(true);
        clearTimeout(intervalRef.current);
      } else {
        // 🔑 Attendre 80s AVANT de relancer, seulement après la fin de l'appel précédent
        intervalRef.current = setTimeout(runScheduler, 20000);
      }
    } catch (error) {
      setMessage("Erreur lors de l'exécution");
    }
  };

  const handleClickDep = () => {
    if (intervalRef.current) clearTimeout(intervalRef.current); // on utilise timeout pas interval
    setDisplay("");
    setStopped(false);
    setProgress(0);
    setMessage("");
    runSchedulerDep();
  };
  return (
    <React.Fragment>
      <div>

        {loading ? (

          <Row>
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <Fragment>
                    <Row style={{marginTop:"15px"}}>
                      <CardTitle style={{ color: "rgba(64,3,56,0.44)",textAlign:"center" }} className="h4">
                        {"Génération automatique d'emploi du temps"}
                      </CardTitle>
                      <CardTitle style={{ color: "#556ee6" }} className="h4">
                        Critéres de Recherches
                      </CardTitle>
                      <Form className="mt-4">
                        <Row>
                          <Col lg="6">
                            <div className="mb-3">
                              <Label for="basicpill-lastname-input2">Département :</Label>
                              <Select
                                options={departement}
                                isSearchable={true}
                                value={selectDepartement}
                                onChange={e => setSelectDepartement(e)}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </Row>
                    <div style={{ marginTop: "15px" }}>
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Col lg="12">
                          <div className="text-center mt-4">
                            {cloture !== 1 && add === 1 && (
                              <>
                                {selectDepartement.value ? (
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: "#05b8b8",
                                      borderColor: "#05b8b8"
                                    }}
                                    className="btn btn-success mb-2 me-2"
                                    onClick={handleClickDep}
                                  >
                                    {"Générer l'emploi par département"}
                                  </button>
                                ) : null}

                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#999f15",
                                    borderColor: "#999f15"
                                  }}
                                  className="btn btn-success mb-2 me-2"
                                  onClick={toggle}
                                >
                                  {"Réinitialiser les données de l'emploi"}
                                </button>
                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#e1a0a4",
                                    borderColor: "#e1a0a4",
                                  }}
                                  className="btn btn-success mb-2 me-2"
                                  onClick={generationEmploi}
                                >
                                  {"Générer l'emploi automatique"}
                                </button>
                                {orders.length > 0 && (
                                  <button
                                    type="button"
                                    style={{
                                      backgroundColor: "#ff0000",
                                      borderColor: "#ff0000",
                                    }}
                                    className="btn btn-success mb-2 me-2"
                                    onClick={handleClick}
                                  >
                                    {
                                      "Forser la génération de l'emploi automatique"
                                    }
                                  </button>
                                )}

                                <div style={{ display: display }}>
                                  <div
                                    style={{
                                      width: "100%",
                                      background: "#eee",
                                      height: "25px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: `${progress}%`,
                                        background: "green",
                                        height: "100%",
                                        transition: "width 0.5s",
                                      }}
                                    />
                                  </div>
                                  <p>Progression : {progress}%</p>
                                  {stopped && <p>✅ Traitement terminé</p>}
                                  {message && <p>📢 Message : {message}</p>}
                                  <h2 style={{ color: "red" }}>
                                    {
                                      "Il ne faut pas rafraîchir l’interface ni quitter la page pour que la génération se complète. "
                                    }
                                  </h2>
                                </div>

                                {uploadPercent > 0 && uploadPercent < 100 && (
                                  <Progress
                                    striped
                                    className="progress-xl"
                                    color="success"
                                    value={uploadPercent}
                                  >
                                    {uploadPercent}%
                                  </Progress>
                                )}

                                {uploadPercent === 100 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Success
                                    <i
                                      style={{
                                        paddingLeft: "5px",
                                        color: "darkcyan",
                                        paddingTop: "3.5px",
                                      }}
                                      className="fas fa-check me-1"
                                    />
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </Col>
                      </div>
                      {orders.length > 0 ? (
                        <Fragment>
                          <Col sm="4">
                            <div className="search-box me-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <BootstrapTable
                            wrapperClasses="table-responsive"
                            noDataIndication={() => <NoDataIndication />}
                            striped={false}
                            bordered={false}
                            classes={"table align-middle table-nowrap"}
                            headerWrapperClasses={"table-light"}
                            hover
                            pagination={paginationFactory(pageOptions)}
                            {...toolkitProps.baseProps}
                          />
                        </Fragment>
                      ) : null}
                    </div>

                  </Fragment>

                )}
              </ToolkitProvider>
            </Col>
          </Row>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Spinner type="grow" className="ms-6" color="primary" />
            </div>
            <h4
              style={{ textAlign: "center", marginTop: "2%" }}
              className="ms-6"
            >
              {" "}
              En cours ...{" "}
            </h4>
          </div>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader
          style={{
            width: "100% !important",
            display: "flex",
            justifyContent: "center",
          }}
          toggle={toggle}
          tag="h4"
        >
          {"Réinitialiser Emploi "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>{"Voulez - vous Réinitialiser Emploi ?"}</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  color="info"
                  className="btn-rounded "
                  onClick={ReinitialiserEmploi}
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Confirmer
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggle}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Annuler
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withRouter(GenerationAuto)
GenerationAuto.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  semestre: PropTypes.object,
}
